<div *ngIf="spinner==true">
  <ngx-spinner size="medium" type="timer">
    <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
  </ngx-spinner>
</div>
<div class="container-fluid">
  <div class="card shadow">
    <div class="card-header">
      <div class="d-flex justify-content-between">
        <h4 class="font-weight-bold text-dark py">OFFICE BEARER</h4>
        <div style="width:120px">
          
          <button type="button" class="btn btn-block btn-danger" data-toggle="modal" [hidden]="isButtonDisabled" data-target="#myModal" (click)="setCurrentdate()">Add</button>
        </div>
      </div>
    </div>
    <div *ngIf="!tableshow" style="margin-left: 50%;">
      <div *ngIf="customers.length == 0" class="loader"></div>
    </div>

    <div class="modal fade" id="modal-xl">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="card-danger">
            <div class="card-header">
              <h3 class="card-title">Edit Office Bearer Information</h3>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="card-body">
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label>Party District / கட்சி மாவட்டம்<span class="required "> *</span></label>
                  <!-- <select class="form-control"  [(ngModel)]="OBDistrict" (click)="OBconstituency_change(OBDistrict)">
                           <option value="null" selected disabled>Select constituency</option> 
                          <option value="" selected disabled>Select District</option>
                          <option *ngFor="let option of district_list" (value)="option" >
                            {{option}}</option>
                        </select> -->
                  <input type="text" name="district1" [(ngModel)]="OBDistrict" class="form-control"
                    placeholder="Party District / கட்சி மாவட்டம்" readonly="readonly" />
                </div>
                <div class="col-sm-6">
                  <label>Assembly constituency / சட்டமன்ற தொகுதி<span class="required "> *</span></label>
                  <select class="form-control" [(ngModel)]="OBConstituency">
                    <option value="" selected disabled>Select constituency</option>
                    <option *ngFor="let option of user_constituency" (value)="option">
                      {{option}}</option>
                  </select>
                  <span *ngIf="OBConstituency=='' && editform.status=='VALID'" class="invalid-msg">Select Constituency
                  </span>
                  <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('constituency').untouched" [hidden]='hidden'>Please select constituency</div> -->
                </div>
              </div>
              <form [formGroup]='editform' (ngSubmit)="updatedata(editform)" autocomplete="off">
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>மாவட்டம் / மாநகரம் / ஒன்றியம் / நகரம் / பகுதி / பேரூர்
                      <span class="required "> *</span></label><br>
                    <select name="applied_posting1" class="form-control" [disabled]="true" [value]="OBapplied_posting">
                      <option value="" disabled selected hidden>Select Option</option>

                      <option value="மாவட்டம்">மாவட்டம்</option>
                      <option value="மாநகரம்">மாநகரம்</option>
                      <option value="ஒன்றியம்">ஒன்றியம்</option>
                      <option value="நகரம்">நகரம்</option>
                      <option value="பகுதி">பகுதி</option>
                      <option value="பேரூர்">பேரூர்</option>

                    </select>


                  </div>




                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>பொறியாளர் அணி பொறுப்பு<span class="required "> *</span></label><br>
                    
                    <input type="text" name="applied_role1" formControlName="applied_role1" class="form-control" [value]="OBold_designation"
                      placeholder="Responsibility / பொறுப்பு" readonly="readonly" />
                    
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>First Name / முதல் பெயர்<span class="required "> *</span></label>
                    <input type="text" name="firstname1" formControlName="firstname1" class="form-control"
                      placeholder="Enter First Name / முதல் பெயர்" />
                    <div *ngIf="firstname1.status=='INVALID' && firstname1.value!=''" class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                    <div *ngIf="(editform.get('firstname1').touched && firstname1.value=='')" class="invalid-msg">Please
                      fill this field</div>
                    <div class="invalid-msg" *ngIf="editform.get('firstname1').untouched && firstname1.value==''">Please
                      fill this field</div>
                  </div>
                  <div class="col-sm-6">
                    <label>Father Name / தந்தையின் பெயர்<span class="required "> *</span></label>
                    <input type="text" name="lastname1" formControlName="lastname1" class="form-control"
                      placeholder="Enter Father Name / தந்தையின் பெயர்" (keyup)="showfathername(editform.get('lastname1').value)"/>
                    <div *ngIf="lastname1.status=='INVALID'&& lastname1.value!=''" class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                    <!-- <div  *ngIf="(editform.get('lastname1').touched && lastname1.value=='')"
                                class="invalid-msg" >Please fill this field</div> -->
                    <div class="invalid-msg" *ngIf="editform.get('lastname1').untouched && lastname1.value==''">Please
                      fill this field</div>

                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Date of Birth / பிறந்த தேதி<span class="required "> *</span></label>
                    <input type="date" name="date_of_birth1" class="form-control" placeholder="Enter Date of Birth"
                      [(ngModel)]="edit_dateofbirth" (ngModelChange)="editcalculateAge()"
                      formControlName="date_of_birth1" />

                  </div>
                  <div class="col-sm-6">
                    <label>Age / வயது</label>
                    <input type="number" name="age1" class="form-control" min="18" max="100" placeholder="Age / வயது"
                      [(ngModel)]="editAge" formControlName="age1" readonly />
                    <span *ngIf="age<18">Age must be 18 or above</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Father Name / தந்தையின் பெயர்<span class="required ">*</span></label>
                    <input type="text" name="father_name1" class="form-control" readonly="readonly"
                      placeholder="Enter Father Name / தந்தையின் பெயர்" formControlName="father_name1" value="{{ln}}" />
                    <!-- <div *ngIf="father_name1.status=='INVALID'&& father_name1.touched==true && father_name1.value!=''" class="invalid-msg">
                                    Numbers and Special charaters not allowed</div>
                                  <div  *ngIf="(editform.get('father_name1').touched && father_name1.value=='')"
                                  class="invalid-msg" >Please fill this field</div>
                                  <div  class="invalid-msg" *ngIf="editform.get('father_name1').untouched && father_name1.value==''">Please fill this field</div> -->
                    <!-- <div *ngIf="editform.get('father_name1').hasError('required')"
                                              class="invalid-msg">Please enter the Father name
                              </div>
                              <div *ngIf="editform.get('father_name1').hasError('pattern') && editform.get('father_name1').touched"
                                          class="invalid-msg">Please enter the valid Name
                                      </div> -->
                  </div>
                  <div class="col-sm-6">
                    <label>Mother Name / தாய் பெயர்</label>
                    <input type="text" name="mother_name" class="form-control"
                      placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name1" />
                    <div *ngIf="mother_name1.status=='INVALID'&& mother_name1.touched==true " class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                    <!-- <div  *ngIf="(editform.get('mother_name1').touched && mother_name1.value=='')"
                                  class="invalid-msg" >Please fill this field</div> -->
                    <!-- <div  class="invalid-msg" *ngIf="editform.get('mother_name1').untouched && mother_name1.value==''">Please fill this field</div> -->
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Degree / கல்வித் தகுதி<span class="required "> *</span></label>
                    <select name="profession" formControlName="educational_qualification1"  class="form-control">
                      <option value="" selected disabled>Select Option</option>
                      <option value="B.E">B.E</option>
                      <option value="DIPLOMA">DIPLOMA</option>                                     
                  </select>
                    <div  *ngIf="(editform.get('educational_qualification1').touched && educational_qualification1.value=='')"
                    class="invalid-msg" >Please fill this field</div>
                    <div  class="invalid-msg" *ngIf="editform.get('educational_qualification1').untouched && educational_qualification1.value==''">Please fill this field</div>
                  </div>

                  <div class="col-sm-6">
                    <label>Degree Major / கல்வித் தகுதியின் பிரிவு<span class="required "> *</span></label>
                    <!-- <input type="text" class="form-control form-control" formControlName="profession"
                        placeholder="Enter Degree Major / கல்வி தகுதின் பிரிவு"> -->
                        <select name="degree_major1" [(ngModel)]="educationOptions" formControlName="degree_major1"  class="form-control">
                            <option value="" selected disabled>Select Option</option>
                            <option value="CIVIL">CIVIL</option>
                            <option value="CSE">CSE</option>
                            <option value="ECE">ECE</option>
                            <option value="EEE">EEE</option>
                            <option value="MECH">MECH</option>
                            <option value="IT">IT</option>
                            <option value="OTHERS">OTHERS</option>
                        </select>
                        <div  class="invalid-msg"  *ngIf="editform.get('degree_major1').untouched" [hidden]='hidden'>Please fill this field</div>
                        <br/>
                            <input *ngIf="educationOptions === 'OTHERS'" class="form-control col-sm-13 mb-3 mb-sm-0" name="	other_qualification" formControlName="other_qualification1" type="text" placeholder="Enter Degree Major / கல்வித் தகுதியின் பிரிவு">
                            <div  *ngIf="educationOptions === 'OTHERS' && editform.get('other_qualification1').value=='' && editform.get('other_qualification1').touched"
                                class="invalid-msg" [hidden]='!hidden'>Please fill this field</div>
                            <div  class="invalid-msg" *ngIf="educationOptions === 'OTHERS' && editform.get('other_qualification1').value==''" [hidden]='hidden'>Please fill this field</div>
                            
                </div> 
              </div>  
                <div class="form-group row">

                  <div class="col-sm-6">
                    <label>Additional Degree / சிறப்பு தகுதி</label>
                    <input type="text" name="additional_qualification" formControlName="additional_qualification1" class="form-control"  placeholder="Enter Additional Degree / சிறப்பு தகுதி"/>
                    <div *ngIf="additional_qualification1.status=='INVALID'&& additional_qualification1.touched==true " class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                    <!-- <div  *ngIf="(editform.get('additional_qualification1').touched && additional_qualification1.value=='')" -->
                      <!-- Numbers not allowed</div> -->
                    <!-- <div  class="invalid-msg" *ngIf="editform.get('additional_qualification1').untouched && additional_qualification1.value==''">Please fill this field</div> -->
                </div>
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label>Email / மின்னஞ்சல்<span class="required "> *</span></label>
                  <input type="text" name="email1" formControlName="email1" class="form-control"  placeholder="Enter Email / மின்னஞ்சல்" (keyup)="getemail(editform.get('email1').value,'EDIT')"/>
                  <!-- <div *ngIf="editform.get('email1').hasError('required') && editform.get('email1').touched"
                      class="invalid-msg">Please fill out this field
                      </div>
                    <div *ngIf="editform.get('email1').hasError('pattern') && editform.get('email1').touched"
                      class="invalid-msg">Please enter the valid Email Id
                    </div>
                    <div *ngIf="editform.get('email1').hasError('required')"
                                class="invalid-msg" [hidden]='hidden'>Please enter the Email
                    </div> -->
                    <div *ngIf="email1.status=='INVALID' && editform.get('email1').value!=''" class="invalid-msg">
                      Please enter the valid Email Id</div>
                    <div  *ngIf="(editform.get('email1').touched && email1.value=='')"
                    class="invalid-msg" >Please fill this field</div>
                    <div  class="invalid-msg" *ngIf="editform.get('email1').untouched && email1.value==''">Please fill this field</div>
                    <div  class="invalid-msg" *ngIf="test_email1=='true' && editform.get('email1').value !=''">This email is already exist and please enter new email.</div>
                  </div>
              </div>

              <div class="form-group row">
                      <div class="col-sm-6 mb-3 mb-sm-0">
                        <label>Phone Number / தொலைபேசி எண்<span class="required "> *</span></label>
                        <input type="text" name="contact_no1" formControlName="contact_no1" class="form-control"  placeholder="Enter Phone Number / தொலைபேசி எண்" maxlength="10"/>
                            <div *ngIf="contact_no1.status=='INVALID'&& contact_no1.touched==true && contact_no1.value!=''" class="invalid-msg">
                              Alphabets and Special characters not allowed</div>
                            <div  *ngIf="(editform.get('contact_no1').touched && contact_no1.value=='')"
                            class="invalid-msg" >Please fill this field</div>
                            <div  class="invalid-msg" *ngIf="editform.get('contact_no1').untouched && contact_no1.value==''">Please fill this field</div>
                        <!-- <div *ngIf="editform.get('contact_no1').hasError('required') && editform.get('contact_no1').touched"
                        class="invalid-msg">Please fill out this field
                      </div>
                      <div  *ngIf="editform.get('contact_no1').hasError('pattern') && editform.get('contact_no1').touched"
                        class="invalid-msg">Please enter the valid Phone Number
                      </div> -->
                      </div>
                      <div class="col-sm-6">
                        <label>Whatsapp Number /வாட்ஸ்அப் எண்<span class="required "> *</span></label>
                        <input type="text" name="whatsapp_no" formControlName="whatsapp_no1" class="form-control"  placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்" maxlength="10"  (keyup)="getphone(editform.get('whatsapp_no1').value,'EDIT')"/>
                            <div *ngIf="whatsapp_no1.status=='INVALID'&& whatsapp_no1.touched==true && whatsapp_no1.value!=''" class="invalid-msg">
                              Please enter valid phone number</div>
                            <div  *ngIf="(editform.get('whatsapp_no1').touched && whatsapp_no1.value=='')"
                            class="invalid-msg" >Please fill this field</div>
                            <div  class="invalid-msg" *ngIf="editform.get('whatsapp_no1').untouched && whatsapp_no1.value==''">Please fill this field</div>
                            <div  class="invalid-msg" *ngIf="test_ph1=='true'&& editform.get('whatsapp_no1').value !=''">This phone number is already exist and please enter new phone.</div>
                            <!-- <div *ngIf="editform.get('whatsapp_no1').hasError('required') && editform.get('whatsapp_no1').touched"
                                class="invalid-msg">Please fill out this field
                            </div>
                            <div *ngIf="editform.get('whatsapp_no1').hasError('pattern') && editform.get('whatsapp_no1').touched"
                                class="invalid-msg">Please enter the valid Whatsapp Number
                            </div>
                            <div *ngIf="editform.get('whatsapp_no1').hasError('required')"
                                          class="invalid-msg" [hidden]='hidden'>Please enter the Whatsapp Number
                          </div> -->
                      </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label>Facebook ID / முகநூல் ஐடி</label>
                  <input type="text" name="fb_id1" formControlName="fb_id1" class="form-control"
                    placeholder="Enter Facebook ID / முகநூல் ஐடி" />
                  
                </div>
                <div class="col-sm-6  mb-3 mb-sm-0">
                  <label>Twitter ID / ட்விட்டர் ஐடி</label>
                  <input type="text" name="twitter_id1" formControlName="twitter_id1" class="form-control"
                    placeholder="Enter Twitter ID / ட்விட்டர் ஐடி" />
                 

                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label>Profession / தொழில்,வேலை</label>
                  <!-- <input pInputText class="form-control" name="profession"  placeholder="Enter Profession / தொழில்,வேலை" formControlName="profession_details"/> -->
                  <select class="form-control"name="profession_details1"  placeholder="Enter Profession / தொழில்,வேலை" formControlName="profession_details1" >
                    <option value="" selected>Select Profession</option>
                    <option *ngFor="let option of prof_list" (value)="option">
                        {{option}}</option>
                </select>
                </div>
                    
                    <div class="col-sm-6">
                        <label>Profession / தொழில்,வேலை</label>
                        <textarea pInputText type="text" class="form-control" name="profession1" formControlName="profession1"  placeholder="Enter Profession / தொழில்,வேலை" ></textarea>
                        
                            <!-- <div  class="invalid-msg" *ngIf="editform.get('profession1').untouched && profession1.value==''">Please fill this field</div> -->
                      </div>
              </div>

               
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">

                    <label>Door no or Flat no / கதவு எண் அல்லது பிளாட் எண்</label>
                    <input pInputText type="text" name="flat_no1" formControlName="flat_no1" pInputText
                      class="form-control" placeholder="Door no or Flat no / கதவு எண் அல்லது பிளாட் எண்" />

                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Street Name / தெருவின் பெயர்</label>
                    <input pInputText type="text" name="street_name1" formControlName="street_name1" pInputText
                      class="form-control" placeholder="Street Name / தெருவின் பெயர்" />


                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Town or City / நகரம்</label>
                    <input pInputText type="text" name="town_city1" formControlName="town_city1" pInputText
                      class="form-control" placeholder="Town or City / நகரம்" />

                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Taluk / தாலுக்கா</label>
                    <input pInputText type="text" name="taluk1" formControlName="taluk1" pInputText class="form-control"
                      placeholder="Taluk / தாலுக்கா" />


                  </div>
                </div>
                <div class="form-group row">

                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Pincode / அஞ்சல் குறியீடு</label>
                    <input pInputText type="text" name="pincode1" formControlName="pincode1" pInputText maxlength="6"
                      class="form-control" placeholder="Pincode / அஞ்சல் குறியீடு" />
                      <div *ngIf="editform.get('pincode1').status =='INVALID' && editform.get('pincode1').touched==true " class="invalid-msg">
                        Please enter valid pincode</div>


                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Status / நிலை<span class="required "> *</span></label><br>
                    <select name="approval_status" formControlName="approval_status1" class="form-control">
                      <option value="" disabled selected hidden>Select Option</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>


                <div class="col-sm-12 mb-3 mb-sm-0">
                  <label>Comments</label>
                  <textarea name="party_comments1" formControlName="party_comments1" pInputText class="form-control"
                    placeholder="Enter Comments" cols="100" rows="5"></textarea>
                  <!-- <div  *ngIf="(editform.get('party_comments1').touched && address1.value=='')"
                                  class="invalid-msg" >Please fill this field</div> -->
                  <!-- <div  class="invalid-msg" *ngIf="editform.get('party_comments1').untouched && party_comments1.value==''">Please fill this field</div> -->
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                      <label>Photo</label><span class="required "> *</span>
                      <input
                      type="file"
                      name="images1"
                      class="form-control"
                      accept="image/*"
                      (change)="onFileChange($event,'edit')">
                      <!-- <div *ngIf="this.officebearerform.get('images1').value==''"
                      class="invalid-msg" [hidden]='hidden'>Please fill out this field
                      </div> -->
                      <div *ngIf="fileFormatStatus" class="invalid-msg">
                        Only allowed extensions are .png .jpeg .jpg</div>
                      <div *ngIf="fileSizeStatus" class="invalid-msg">
                        Maximum allowed file size is 60KB</div>
                  </div>

                  <img [src]="userImage"  *ngIf="userImage" style="height: 190px; width:160px; border: 1px solid #555; " >

                </div>

                <div class="py-2">
                  <div class="d-flex justify-content-center">
                    <div style="width:200px">
                      <button class="btn btn-danger btn btn-block" data-toggle="modal" data-target="#message"
                        data-backdrop="false">Update Office Bearer</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <div [ngClass]="{ 'modal fade': isClassEnabled }" id="showDialog">
      <div [ngClass]="{ 'modal-dialog modal-xl': isClassEnabled }">
        <div [ngClass]="{ 'modal-content': isClassEnabled }" >
          <div class="card-danger">
            <div class="card-header">
              <h3 class="card-title">Office Bearer Information (Non-Editable)</h3>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="card-body" >
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label>Party District / கட்சி மாவட்டம்:</label>
                  <!-- <select class="form-control"  [(ngModel)]="OBDistrict" [disabled]="true" (click)="Constituency_selection(district)">
                          <option *ngFor="let option of district_list" (value)="option" >
                            {{option}}</option>
                        </select> -->
                  <input type="text" name="district" [(ngModel)]="OBDistrict" class="form-control"
                    placeholder="Party District / கட்சி மாவட்டம்" readonly="readonly" />

                </div>
                <div class="col-sm-6">
                  <label>Assembly constituency / சட்டமன்ற தொகுதி:</label>
                  <select class="form-control" [(ngModel)]="OBConstituency" [disabled]="true">
                    <option *ngFor="let option of user_constituency" (value)="option">
                      {{option}}</option>
                  </select>
                </div>
              </div>
              <form>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>மாவட்டம் / மாநகரம் / ஒன்றியம் / நகரம் / பகுதி / பேரூர்
                      </label><br>
                    <select name="applied_posting" class="form-control" [disabled]="true" [value]="OBapplied_posting">
                      <option value="" disabled selected hidden>Select Option</option>

                      <option value="மாவட்டம்">மாவட்டம்</option>
                      <option value="மாநகரம்">மாநகரம்</option>
                      <option value="ஒன்றியம்">ஒன்றியம்</option>
                      <option value="நகரம்">நகரம்</option>
                      <option value="பகுதி">பகுதி</option>
                      <option value="பேரூர்">பேரூர்</option>

                    </select>


                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label> பொறியாளர் அணி பொறுப்பு</label><br>
                    <input type="text" name="applied_role1" class="form-control" [value]="OBold_designation"
                    placeholder="Responsibility / பொறுப்பு" readonly="readonly" />
                    <!-- <select name="applied_role" class="form-control" [disabled]="true" [value]="OBold_designation" >
                      <option value="" disabled selected hidden>Select Option</option>
                      <option value="மாவட்ட தலைவர்">மாவட்ட தலைவர்</option>
                      <option value="மாவட்ட துணை தலைவர்">மாவட்ட துணை தலைவர்</option>
                      <option value="மாவட்ட அமைப்பாளர்">மாவட்ட அமைப்பாளர்</option>
                      <option value="மாவட்ட துணை அமைப்பாளர்">மாவட்ட துணை அமைப்பாளர்</option>

                      <option value="மாநகர அமைப்பாளர்">மாநகர அமைப்பாளர்</option>
                      <option value="மாநகர துணை அமைப்பாளர்">மாநகர துணை அமைப்பாளர்</option>

                      <option value="ஒன்றிய அமைப்பாளர்">ஒன்றிய அமைப்பாளர்</option>
                      <option value="ஒன்றிய துணை அமைப்பாளர்">ஒன்றிய துணை அமைப்பாளர்</option>

                      <option value="நகர அமைப்பாளார்">நகர அமைப்பாளார்</option>
                      <option value="நகர துணை அமைப்பாளர்">நகர துணை அமைப்பாளர்</option>

                      <option value="பகுதி அமைப்பாளர்">பகுதி அமைப்பாளர்</option>
                      <option value="பகுதி துணை அமைப்பாளர்">பகுதி துணை அமைப்பாளர்</option>

                      <option value="பேரூர் அமைப்பாளர்">பேரூர் அமைப்பாளர்</option>
                      <option value="பேரூர் துணை அமைப்பாளர்">பேரூர் துணை அமைப்பாளர்</option>
                    </select> -->
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>First Name / முதல் பெயர்</label>
                    <input type="text" class="form-control" [disabled]="true" placeholder="Enter First Name / முதல் பெயர்"
                      [value]="OBname" />
                  </div>
                  <div class="col-sm-6">
                    <label>Father Name / தந்தையின் பெயர்</label>
                    <input type="text" name="lastname" class="form-control" [disabled]="true"
                      placeholder="Enter Father Name / தந்தையின் பெயர்" [value]="OBlastname" />
                  </div>
                </div>
                <div class="form-group row">

                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Date of Birth / பிறந்த தேதி</label>
                    <input type="date" name="date_of_birth" class="form-control" [disabled]="true"
                      placeholder="Enter Date of Birth" [value]="OBdateofbirth" />
                  </div>
                  <div class="col-sm-6">
                    <label>Age / வயது</label>
                    <input type="number" name="age" class="form-control" [disabled]="true" min="18" max="100"
                      placeholder="Age / வயது" [value]="OBage" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Father Name / தந்தையின் பெயர்</label>
                    <input type="text" name="father_name" class="form-control" [disabled]="true"
                      placeholder="Enter Father Name / தந்தையின் பெயர்" [value]="OBfathername" />
                  </div>

                  <div class="col-sm-6">
                    <label>Mother Name / தாய் பெயர்</label>
                    <input type="text" name="mother_name" class="form-control" readonly
                      placeholder="Enter Mother Name / தந்தையின் பெயர்" [value]="OBmothername" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Degree / கல்வித் தகுதி</label>
                    <input type="text" name="educational_qualification" class="form-control" [disabled]="true" placeholder="Enter Degree / கல்வித் தகுதி"[value]="OBdegree"/>
                  </div>
                  <div class="col-sm-6">
                    <label>Degree Major / கல்வித் தகுதியின் பிரிவு</label>
                    <!-- <input type="text" class="form-control form-control" formControlName="profession"
                        placeholder="Enter Degree Major / கல்வி தகுதின் பிரிவு"> -->
                        <input type="text"  name="degree_major"  [(ngModel)]="educationOptions"   class="form-control" [value]="OBdegree_major" [disabled]="true">
                    
                        <br/>
                        <div  *ngIf="OBdegree_major == 'OTHERS'">
                            <!-- <input *ngIf="educationOptions === 'OTHERS'" type="text" class="form-control col-sm-6 mb-3 mb-sm-0" id="additional_qualification" ngModel name="additional_qualification"> -->
                            <input class="form-control col-sm-13 mb-3 mb-sm-0" name="	other_qualification" [value]="OBother_qualification" type="text" placeholder="Enter Degree Major / கல்வித் தகுதியின் பிரிவு" [disabled]="true">
                        </div>
                </div> 
              </div>
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Additional Degree / சிறப்பு தகுதி</label>
                  <input type="text" name="additional_qualification" class="form-control" [disabled]="true" placeholder="Enter Additional Degree / சிறப்பு தகுதி"[value]="OBaddtionaldegree"/>
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Email / மின்னஞ்சல்</label>
                    <input type="text" name="email" class="form-control" [disabled]="true" placeholder="Enter Email / மின்னஞ்சல்"[value]="OBmail"/>
                  </div>
              </div>

              <div class="form-group row">
                      <div class="col-sm-6 mb-3 mb-sm-0">
                        <label>Phone Number / தொலைபேசி எண்</label>
                        <input type="text" name="contact_no" class="form-control" [disabled]="true" placeholder="Enter Phone Number / தொலைபேசி எண்"[value]="OBphonenumber"/>
                      </div>
                      <div class="col-sm-6">
                        <label>Whatsapp Number /வாட்ஸ்அப் எண்</label>
                        <input type="text" name="whatsapp_no" class="form-control" [disabled]="true" placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்"[value]="whatsappnumner"/>
                      </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label>
                    Facebook ID / முகநூல் ஐடி
                    </label>
                  <input type="text" name="father_name" class="form-control" [disabled]="true"
                    placeholder="Enter Facebook ID / முகநூல் ஐடி
                    " [value]="OBfb_id" />
                </div>

                <div class="col-sm-6">
                  <label>Twitter ID / ட்விட்டர் ஐடி</label>
                  <input type="text" name="mother_name" class="form-control" readonly
                    placeholder="Enter Twitter ID / ட்விட்டர் ஐடி" [value]="OBtwitter_id" />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label>Profession / தொழில்,வேலை</label>
                  <input type="text"  name="profession_details" class="form-control" [disabled]="true" placeholder="Enter Profession / தொழில்,வேலை"[value]="OBprofession_details"/>
                </div>
                  
                    <div class="col-sm-6">
                      <label>Profession Details/ தொழில் விவரங்கள்</label>
                      <textarea pInputText type="text"  name="profession" class="form-control" name="profession" [disabled]="true" placeholder="Enter Profession / தொழில்,வேலை"[value]="OBprofession"></textarea>
                    </div>
              </div>

                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">

                    <label>Door no or Flat no / கதவு எண் அல்லது பிளாட் எண்</label>
                    <input pInputText type="text" name="flat_no" class="form-control" [disabled]="true"
                      placeholder="Door no or Flat no / கதவு எண் அல்லது பிளாட் எண்" [value]="OBflat_no" />
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Street Name / தெருவின் பெயர்</label>
                    <input pInputText type="text" class="form-control" name="street_name" [disabled]="true"
                      placeholder="Street Name / தெருவின் பெயர்" [value]="OBstreet_name" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Town or City / நகரம்</label>
                    <input pInputText type="text" class="form-control" name="town_city" [disabled]="true"
                      placeholder="Town or City / நகரம்" [value]="OBtown_city" />
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Taluk / தாலுக்கா</label>
                    <input pInputText type="text" class="form-control" name="taluk" [disabled]="true"
                      placeholder="Taluk / தாலுக்கா" [value]="OBtaluk" />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Pincode / அஞ்சல் குறியீடு</label>
                    <input pInputText type="text" class="form-control" name="pincode" [disabled]="true"
                      placeholder="Pincode / அஞ்சல் குறியீடு" [value]="OBpincode" />
                  </div>

                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Status / நிலை<span class="required "></span></label><br>
                    <select name="approval_status" [disabled]="true" [value]="OBstatus" class="form-control">
                      <option value="" disabled selected hidden>Select Option</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>



                  <div class="col-sm-12 mb-3 mb-sm-0">
                    <label>Comments</label>
                    <textarea name="party_comments" pInputText class="form-control" [disabled]="true"
                      placeholder="Enter Comments" cols="100" rows="5" [value]="OBcomments"></textarea>
                  </div>
                  
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <div >
                      <label>Photo (Preview)</label><br>
                      <img [src]="userImage"  style="height: 190px; width:160px; border: 1px solid #555; " >
                    </div>
                  </div>
                </div>
                <div style="width:70px">
                  <button type="button" class="btn btn-block btn-dark" (click)="PrintViewForm()">Print</button>
                </div>
                  
               
                <!-- <div class="col-3" style="margin-left:34%;">
                          <a  class="btn btn-danger btn btn-block">
                            UPDATE OFFICE BEARER
                          </a>
                        </div> -->
              </form>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div class="modal fade" id="myModal" *ngIf="user_password==null">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="card-danger">
            <div class="card-header">
              <h3 class="card-title" (click)="print()">Create office bearer</h3>
              <button type="button" class="close" data-dismiss="modal" (click)="FormReset()">&times;</button>
            </div>
            <div class="card-body">
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label>Party District / கட்சி மாவட்டம்<span class="required "> *</span></label><br>
                  <!-- <select class="form-control"  [(ngModel)]="district" (click)="Constituency_selection(district)">
                            <option value="" selected disabled hidden>Select District</option>
                            <option *ngFor="let option of district_list" (value)="option" >
                              {{option}}</option>
                          </select> -->
                  <input type="text" name="district" [(ngModel)]="district" class="form-control"
                    placeholder="Party District / கட்சி மாவட்டம்" readonly="readonly" />
                </div>

                <div class="col-sm-6">
                  <label>Assembly constituency / சட்டமன்ற தொகுதி<span class="required "> *</span></label><br>
                  <select class="form-control" [(ngModel)]="constituency">
                    <option value="" selected disabled hidden>Select constituency</option>
                    <option *ngFor="let option of user_constituency" (value)="option">
                      {{option}}</option>
                  </select>
                  <!-- <div *ngIf="!constituency && officebearerform.status=='VALID' " class="invalid-msg">Select
                    Constituency
                  </div> -->
                  <div class="invalid-msg" *ngIf="!constituency" [hidden]='hidden'>Select Constituency
                  </div>
                  <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('constituency').untouched" [hidden]='hidden'>Please select constituency</div> -->

                  <!-- <div *ngIf="officebearerform.get('constituency').touched && officebearerform.get('constituency') !=''">
                              Numbers and Special charaters not allowed
                            </div> -->
                </div>
              </div>
              <!-- <div class="">
                        <div class="d-flex justify-content-between">
                          <label class="col-2" >District/மாவட்டம்:</label><br>
                          <select class="form-control"  [(ngModel)]="district" (click)="Constituency_selection(district)">
                            <option *ngFor="let option of district_list" (value)="option" >
                              {{option}}</option>
                          </select>

                            <label class="col-2">Assembly constituency/சட்டமன்ற தொகுதி:</label>
                            <select class="form-control"  [(ngModel)]="constituency">
                              <option *ngFor="let option of user_constituency" (value)="option" >
                                {{option}}</option>
                            </select>
                            <span *ngIf="!constituency"
                                      class="invalid-msg">Select Constituency
                            </span>
                        </div>
                      </div> -->
              <!-- <div class="form-group row">
                        <div class="col-sm-6 mb-3 mb-sm-0">
                          <label>Responsibility for Applying to District Posting Name / மாவட்ட அணி பொறுப்பு
                            <span class="required "> *</span></label><br>
                          <select name="applied_posting" class="form-control" formControlName="applied_posting">
                              <option value="" selected disabled hidden>Select Option</option>
                             
                              <option value="">மாவட்டம்</option>
                              <option value="மாநகரம்">மாநகரம்</option>
                              <option value="ஒன்றியம்">ஒன்றியம்</option>
                              <option value="பேரூர்">பேரூர்</option>
                              <option value="பகுதி">பகுதி</option>
                          </select>
                          
                          <div  *ngIf="(officebearerform.get('applied_posting').touched && applied_role.value=='')"
                          class="invalid-msg" >Please select this field</div>
                          <div  class="invalid-msg" *ngIf="officebearerform.get('applied_posting').untouched" [hidden]='hidden'>Please select this field</div>
                          <div  class="invalid-msg" *ngIf="officebearerform.get('applied_posting').value !=''" >The maximum number of user for this role has been created</div>
                    
                      </div>
                        </div> -->


              <form [formGroup]='officebearerform' (ngSubmit)="postdata(officebearerform)" autocomplete="off">
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>மாவட்டம் / மாநகரம் / ஒன்றியம் / நகரம் / பகுதி / பேரூர்
                      <span class="required "> *</span></label><br>
                    <select name="applied_posting" class="form-control" formControlName="applied_posting"
                    (change)="getPostingDropdown(officebearerform.value.applied_posting)">
                      <option value="" selected disabled hidden>Select Option</option>

                      <option value="மாவட்டம்">மாவட்டம்</option>
                      <option value="மாநகரம்">மாநகரம்</option>
                      <option value="ஒன்றியம்">ஒன்றியம்</option>
                      <option value="நகரம்">நகரம்</option>
                      <option value="பகுதி">பகுதி</option>
                      <option value="பேரூர்">பேரூர்</option>

                    </select>

                    <div *ngIf="officebearerform.get('applied_posting').hasError('required')" class="invalid-msg"
                      [hidden]='hidden'>Please fill out this field
                    </div>


                  </div>
                  <div class="col-sm-6">
                    <label>மாவட்ட பொறியாளர் அணி பொறுப்பு<span class="required "> *</span></label><br>
                    <select name="applied_role" class="form-control" formControlName="applied_role" (click)="nopost_msg()" >

                      <option value="" selected disabled hidden>Select Option</option>
                      <option *ngFor="let option of dropdown_list" (value)="option" >
                        {{option}}</option>

                      <!-- <option *ngIf="applied_posting111=='true'" value="மாவட்ட தலைவர்">மாவட்ட தலைவர்</option>
                      <option *ngIf="applied_posting112=='true'" value="மாவட்ட துணைத் தலைவர்">மாவட்ட துணைத் தலைவர்</option>
                      <option *ngIf="applied_posting113=='true'" value="மாவட்ட அமைப்பாளர்">மாவட்ட அமைப்பாளர்</option>
                      <option *ngIf="applied_posting114=='true'" value="மாவட்ட துணை அமைப்பாளர் 1">மாவட்ட துணை அமைப்பாளர்
                        1</option>
                      <option *ngIf="applied_posting115=='true'" value="மாவட்ட துணை அமைப்பாளர் 2">மாவட்ட துணை அமைப்பாளர்
                        2</option>
                      <option *ngIf="applied_posting116=='true'" value="மாவட்ட துணை அமைப்பாளர் 3">மாவட்ட துணை அமைப்பாளர்
                        3</option>
                      <option *ngIf="applied_posting117=='true'" value="மாவட்ட துணை அமைப்பாளர் 4">மாவட்ட துணை அமைப்பாளர்
                        4</option>
                      <option *ngIf="applied_posting118=='true'" value="மாவட்ட துணை அமைப்பாளர் 5">மாவட்ட துணை அமைப்பாளர்
                        5</option>

                      <option *ngIf="applied_posting119=='true'" value="மாநகர அமைப்பாளர்">மாநகர அமைப்பாளர்</option>
                      <option *ngIf="applied_posting120=='true'" value="மாநகர துணை அமைப்பாளர் 1">மாநகர துணை அமைப்பாளர் 1
                      </option>
                      <option *ngIf="applied_posting121=='true'" value="மாநகர துணை அமைப்பாளர் 2">மாநகர துணை அமைப்பாளர் 2
                      </option>
                      <option *ngIf="applied_posting122=='true'" value="மாநகர துணை அமைப்பாளர் 3">மாநகர துணை அமைப்பாளர் 3
                      </option>
                      <option *ngIf="applied_posting123=='true'" value="மாநகர துணை அமைப்பாளர் 4">மாநகர துணை அமைப்பாளர் 4
                      </option>
                      <option *ngIf="applied_posting124=='true'" value="மாநகர துணை அமைப்பாளர் 5">மாநகர துணை அமைப்பாளர் 5
                      </option>



                      <option *ngIf="applied_posting125=='true'" value="ஒன்றிய அமைப்பாளர்">ஒன்றிய அமைப்பாளர்</option>
                      <option *ngIf="applied_posting126=='true'" value="ஒன்றிய துணை அமைப்பாளர் 1">ஒன்றிய துணை அமைப்பாளர்
                        1</option>
                      <option *ngIf="applied_posting127=='true'" value="ஒன்றிய துணை அமைப்பாளர் 2">ஒன்றிய துணை அமைப்பாளர்
                        2</option>
                      <option *ngIf="applied_posting128=='true'" value="ஒன்றிய துணை அமைப்பாளர் 3">ஒன்றிய துணை அமைப்பாளர்
                        3</option>





                      <option *ngIf="applied_posting129=='true'" value="நகர அமைப்பாளார்">நகர அமைப்பாளார்</option>
                      <option *ngIf="applied_posting130=='true'" value="நகர துணை அமைப்பாளர் 1">நகர துணை அமைப்பாளர் 1
                      </option>
                      <option *ngIf="applied_posting131=='true'" value="நகர துணை அமைப்பாளர் 2">நகர துணை அமைப்பாளர் 2
                      </option>
                      <option *ngIf="applied_posting132=='true'" value="நகர துணை அமைப்பாளர் 3">நகர துணை அமைப்பாளர் 3
                      </option>

                      <option *ngIf="applied_posting133=='true'" value="பகுதி அமைப்பாளர்">பகுதி அமைப்பாளர்</option>
                      <option *ngIf="applied_posting134=='true'" value="பகுதி துணை அமைப்பாளர் 1">பகுதி துணை அமைப்பாளர் 1
                      </option>
                      <option *ngIf="applied_posting135=='true'" value="பகுதி துணை அமைப்பாளர் 2">பகுதி துணை அமைப்பாளர் 2
                      </option>
                      <option *ngIf="applied_posting136=='true'" value="பகுதி துணை அமைப்பாளர் 3">பகுதி துணை அமைப்பாளர் 3
                      </option>

                      <option *ngIf="applied_posting137=='true'" value="பேரூர் அமைப்பாளர்">பேரூர் அமைப்பாளர்</option>
                      <option *ngIf="applied_posting138=='true'" value="பேரூர் துணை அமைப்பாளர் 1">பேரூர் துணை அமைப்பாளர் 1</option>
                      <option *ngIf="applied_posting139=='true'" value="பேரூர் துணை அமைப்பாளர் 2">பேரூர் துணை அமைப்பாளர் 2</option>
                      <option *ngIf="applied_posting140=='true'" value="பேரூர் துணை அமைப்பாளர் 3">பேரூர் துணை அமைப்பாளர் 3</option> -->
                      <!-- </option>
    <option *ngIf="(applied_posting111 =='false' && applied_posting112  =='false'&& applied_posting113 =='false' &&applied_posting114  =='false' && applied_posting115 =='false' && applied_posting116 =='false' && applied_posting117 =='false' && applied_posting118 =='false'
     && applied_posting119=='false' && applied_posting120 =='false' && applied_posting121  =='false'&& applied_posting122 =='false' && applied_posting123 =='false' && applied_posting124 =='false' && applied_posting125 =='false' && applied_posting126 =='false' && applied_posting127 =='false'
      && applied_posting128=='false'&& applied_posting129 =='false' && applied_posting130 =='false' && applied_posting131 =='false' && applied_posting132 =='false' && applied_posting133 =='false' && applied_posting134 =='false' && applied_posting135  =='false'&& applied_posting136  =='false'
       && applied_posting137=='false' && applied_posting138=='false')  " value="">It seems all the posts for this district has been filled. You cannot create Office bearer for this district.
                  </option> -->
                    </select>

                    <div class="invalid-msg"
                      *ngIf="dropdown_list=='' && nopost_Error_msg==true && applied_posting.value!='';else err">It seems all the posts for this district has been filled.<br> You cannot create Office bearer for this district.
                     </div>
                     <ng-template #err>
                      <div *ngIf="officebearerform.get('applied_role').hasError('required')" class="invalid-msg"
                      [hidden]='hidden'>Please fill out this field  </div>
                    </ng-template>

                    
                      

                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>First Name / முதல் பெயர்<span class="required "> *</span></label>
                    <input type="text" name="firstname" class="form-control" placeholder="Enter First Name / முதல் பெயர்"
                      formControlName="firstname" />
                    <div *ngIf="firstname.status=='INVALID'&& firstname.touched==true && firstname.value!=''"
                      class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                    <div *ngIf="(officebearerform.get('firstname').touched && firstname.value=='')" class="invalid-msg">
                      Please fill this gowtham field</div>
                    <div class="invalid-msg" *ngIf="officebearerform.get('firstname').untouched  && firstname.value==''" [hidden]='hidden'>
                      Please fill this saravanan field</div>
                  </div>
                  <div class="col-sm-6">
                    <label>Father Name / தந்தையின் பெயர்<span class="required "> *</span></label>
                    <input type="text" name="lastname" class="form-control"
                      placeholder="Enter Father Name / தந்தையின் பெயர்" formControlName="lastname" (keyup)="showfathername(officebearerform.get('lastname').value)"/>
                    <div *ngIf="lastname.status=='INVALID'&& lastname.touched==true && lastname.value!=''"
                      class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                    <div *ngIf="(officebearerform.get('lastname').touched && lastname.value=='')" class="invalid-msg">
                      Please fill this field</div>
                    <div class="invalid-msg" *ngIf="officebearerform.get('lastname').untouched && lastname.value==''" [hidden]='hidden'>Please
                      fill this field</div>

                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Date of Birth / பிறந்த தேதி<span class="required "> *</span></label>
                    <input type="date" name="date_of_birth" class="form-control" placeholder="Enter Date of Birth"
                      [(ngModel)]="date_of_birth" (ngModelChange)="calculateAge()" formControlName="date_of_birth"
                      max="{{minAge1 | date:'yyyy-MM-dd'}}" />
                    <!-- <div  *ngIf="date_of_birth.touched && date_of_birth.value==''"
                                  class="invalid-msg" >Please fill this field</div> -->
                    <!-- <div class="invalid-msg" *ngIf="!date_of_birth && hidden==false">Please fill this field</div> -->
                    <div  *ngIf="(officebearerform.get('date_of_birth').touched && date_of_birth=='')"
                    class="invalid-msg" >Please fill this field</div>
                    <div  class="invalid-msg" *ngIf="officebearerform.get('date_of_birth').untouched && date_of_birth==''" [hidden]='hidden'>Please fill this field</div>
                  </div>
                  <div class="col-sm-6">
                    <label>Age / வயது<span class="required "> *</span></label>
                    <input type="number" name="age" class="form-control age" [(ngModel)]="age" min="18" max="100"
                      placeholder="Age / வயது" formControlName="age" readonly />
                    <span *ngIf="age<18" class="invalid-msg">Age must be 18 or above</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Father Name / தந்தையின் பெயர்<span class="required "> *</span></label>
                    <input type="text" name="father_name" class="form-control"
                      placeholder="Enter Father Name / தந்தையின் பெயர்" readonly="readonly" value="{{ln}}"
                      formControlName="father_name" />
                    <!-- <div *ngIf="father_name.status=='INVALID'&& father_name.touched==true && father_name.value!=''" class="invalid-msg">
                                      Numbers and Special charaters not allowed</div>
                                    <div  *ngIf="(officebearerform.get('father_name').touched && father_name.value=='')"
                                    class="invalid-msg" >Please fill this field</div>
                                    <div  class="invalid-msg" *ngIf="officebearerform.get('father_name').untouched" [hidden]='hidden'>Please fill this field</div> -->
                  </div>
                  <div class="col-sm-6">
                    <label>Mother Name / தாய் பெயர்</label>
                    <input type="text" name="mother_name" class="form-control"
                      placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name" />

                    <div *ngIf="mother_name.status=='INVALID'&& mother_name.touched==true " class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                    <!-- <div  *ngIf="(officebearerform.get('mother_name').touched && mother_name.value=='')"
                                    class="invalid-msg" >Please fill this field</div> -->
                    <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('mother_name').untouched" [hidden]='hidden'>Please fill this field</div> -->
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Degree / கல்வித் தகுதி<span class="required "> *</span></label>
                    <!-- <input type="text" name="educational_qualification" class="form-control"  placeholder="Enter Degree / கல்வித் தகுதி" formControlName="educational_qualification"/> -->
                         
                    <select name="educational_qualification" formControlName="educational_qualification"  class="form-control">
                      <option value="" selected disabled>Select Option</option>
                      <option value="B.E">B.E</option>
                      <option value="DIPLOMA">DIPLOMA</option>                                     
                  </select>
                    
                    
                    <!-- <div *ngIf="educational_qualification.status=='INVALID'&& educational_qualification.touched==true && educational_qualification.value!=''" class="invalid-msg">
                            Numbers and Special charaters not allowed</div> -->
                          <div  *ngIf="(officebearerform.get('educational_qualification').touched && officebearerform.get('educational_qualification').value=='')"
                          class="invalid-msg" >Please fill this field</div>
                          <div  class="invalid-msg" *ngIf="officebearerform.get('educational_qualification').untouched && officebearerform.get('educational_qualification').value==''" [hidden]='hidden'>Please fill this field</div>
                  </div>

                  <div class="col-sm-6">
                    <label>Degree Major / கல்வித் தகுதியின் பிரிவு<span class="required "> *</span></label>
                    <!-- <input type="text" class="form-control form-control" formControlName="profession"
                        placeholder="Enter Degree Major / கல்வி தகுதின் பிரிவு"> -->
                        <select name="degree_major" [(ngModel)]="educationOptions" formControlName="degree_major" (click)="degree_major_role=='true'" placeholder="Select Option" class="form-control">
                            <option *ngIf=" degree_major_role=='false'"   value="" selected disabled>Select Option</option>
                            <option value="CIVIL">CIVIL</option>
                            <option value="CSE">CSE</option>
                            <option value="ECE">ECE</option>
                            <option value="EEE">EEE</option>
                            <option value="MECH">MECH</option>
                            <option value="IT">IT</option>
                            <option value="OTHERS">OTHERS</option>
                        </select>
                        <div  class="invalid-msg"  *ngIf="officebearerform.get('degree_major').untouched && officebearerform.get('degree_major').value==''" [hidden]='hidden'>Please fill this field</div>
                        <br/>
                            <!-- <input *ngIf="educationOptions === 'OTHERS'" type="text" class="form-control col-sm-6 mb-3 mb-sm-0" id="additional_qualification" ngModel name="additional_qualification"> -->
                            <input *ngIf="educationOptions === 'OTHERS'" class="form-control col-sm-13 mb-3 mb-sm-0" name="other_qualification" formControlName="other_qualification" type="text" placeholder="Enter Degree Major / கல்வித் தகுதியின் பிரிவு">
                            <div  *ngIf="educationOptions === 'OTHERS' && officebearerform.get('other_qualification').value=='' && officebearerform.get('other_qualification').touched"
                            class="invalid-msg" [hidden]='!hidden'>Please fill this field</div>
                            <div  class="invalid-msg" *ngIf="educationOptions === 'OTHERS' && officebearerform.get('other_qualification').value==''" [hidden]='hidden'>Please fill this field</div>
                    
                </div> 
              </div>  
                <div class="form-group row">

                  <div class="col-sm-6">
                    <label>Additional Degree / சிறப்பு தகுதி</label>
                    <input type="text" name="additional_qualification" class="form-control"  placeholder="Enter Additional Degree / சிறப்பு தகுதி" formControlName="additional_qualification"/>
                    <div *ngIf="additional_qualification.status=='INVALID'&& additional_qualification.touched==true " class="invalid-msg">
                      Numbers and Special charaters not allowed</div>
                          <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('additional_qualification').untouched" [hidden]='hidden'>Please fill this field</div> --> 
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Email / மின்னஞ்சல்<span class="required "> *</span></label>
                    <input type="text" name="email" class="form-control"  placeholder="Enter Email / மின்னஞ்சல்" formControlName="email"  (keyup)="getemail(officebearerform.get('email').value,'ADD')"/>
                     <!-- <div *ngIf="officebearerform.get('email').hasError('required') && officebearerform.get('email').touched"
                       class="invalid-msg">Please fill out this field
                      </div>
                     <div *ngIf="officebearerform.get('email').hasError('pattern') && officebearerform.get('email').touched"
                      class="invalid-msg">Please enter the valid Email Id
                    </div>
                    <div *ngIf="officebearerform.get('email').hasError('required')"
                        class="invalid-msg" [hidden]='hidden'>Please fill out this field
                      </div> -->
                        <div *ngIf="email.status=='INVALID'&& email.touched==true && email.value!=''" class="invalid-msg">
                          Please enter the valid Email Id</div>
                        <div  *ngIf="(officebearerform.get('email').touched && email.value=='')"
                        class="invalid-msg" >Please fill this field</div>
                        <div  class="invalid-msg" *ngIf="officebearerform.get('email').untouched && email.value==''" [hidden]='hidden'>Please fill this field</div>
                        <div  class="invalid-msg" *ngIf="test_email=='true' && officebearerform.get('email').value !=''">This email is already exist and please enter new email.</div>
                      </div>
              </div>

              <div class="form-group row">
                      <div class="col-sm-6 mb-3 mb-sm-0">
                        <label>Phone Number / தொலைபேசி எண்<span class="required "> *</span></label>
                        <input type="text" name="contact_no" class="form-control"  placeholder="Enter Phone Number / தொலைபேசி எண்" maxlength="10" formControlName="contact_no"/>
                            <div *ngIf="contact_no.status=='INVALID'&& contact_no.touched==true && contact_no.value!=''" class="invalid-msg">
                              Please enter the valid phone number</div>
                            <div  *ngIf="(officebearerform.get('contact_no').touched && contact_no.value=='')"
                            class="invalid-msg" >Please fill this field</div>
                            <div  class="invalid-msg" *ngIf="officebearerform.get('contact_no').untouched && contact_no.value==''" [hidden]='hidden'>Please fill this field</div>
                        <!-- <div *ngIf="officebearerform.get('contact_no').hasError('required') && officebearerform.get('contact_no').touched"
                          class="invalid-msg">Please fill out this field
                        </div>
                        <div  *ngIf="officebearerform.get('contact_no').hasError('pattern') && officebearerform.get('contact_no').touched"
                          class="invalid-msg">Please enter the valid Phone Number
                        </div>
                        <div *ngIf="officebearerform.get('contact_no').hasError('required')"
                          class="invalid-msg" [hidden]='hidden'>Please fill out this field
                        </div> -->
                      </div>
                      <div class="col-sm-6">
                        <label>Whatsapp Number / வாட்ஸ்அப் எண்<span class="required "> *</span></label>
                        <input type="text" name="whatsapp_no" class="form-control"  placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்" maxlength="10" formControlName="whatsapp_no"  [readonly]="isWhatsAppNumberDisabled"  (keyup)="getphone(officebearerform.get('whatsapp_no').value,'ADD')"/>
                              <div *ngIf="whatsapp_no.status=='INVALID'&& whatsapp_no.touched==true && whatsapp_no.value!=''" class="invalid-msg">
                                Please enter the valid WhatsApp Number</div>
                                <div  *ngIf="(officebearerform.get('whatsapp_no').touched && whatsapp_no.value=='' && officebearerform.get('whatsapp_no').hasError('pattern'))"
                                class="invalid-msg" >Please fill this field</div>
                              <div  class="invalid-msg" *ngIf="officebearerform.get('whatsapp_no').untouched && whatsapp_no.value==''" [hidden]='hidden'>Please fill this field</div>
                              <!-- <span *ngIf="officebearerform.get('whatsapp_no').errors?.['minlength'] || officebearerform.get('whatsapp_no').errors?.['maxlength']">10 digit number required</span> -->
                              <div  class="invalid-msg" *ngIf="test_ph=='true'&& officebearerform.get('whatsapp_no').value !=''">This phone number is already exist and please enter new phone.</div>
                            </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label>
                    Facebook ID / முகநூல் ஐடி
                    </label>
                  <input type="text" name="fb_id" class="form-control" placeholder="Enter Facebook ID / முகநூல் ஐடி"
                    formControlName="fb_id" />
                 
                </div>
                <div class="col-sm-6">
                  <label>Twitter ID / ட்விட்டர் ஐடி</label>
                  <input type="text" name="twitter_id" class="form-control"
                    placeholder="Enter Twitter ID / ட்விட்டர் ஐடி" formControlName="twitter_id" />
                  

                </div>
              </div>
              <div class="form-group row">
                    
                <div class="col-sm-6">
                  <label>Profession / தொழில்,வேலை</label>
                  <!-- <input pInputText class="form-control" name="profession"  placeholder="Enter Profession / தொழில்,வேலை" formControlName="profession_details"/> -->
                  <select class="form-control"name="profession_details"  placeholder="Enter Profession / தொழில்,வேலை" formControlName="profession_details" >
                    <option value="" selected>Select Profession</option>
                    <option *ngFor="let option of prof_list" (value)="option">
                        {{option}}</option>
                </select>
                </div>
                <div class="col-sm-6">
                  <label>Profession details / தொழில் விவரங்கள்</label>
                  <textarea pInputText class="form-control" name="profession"  placeholder="Enter Profession details / தொழில் விவரங்கள்" formControlName="profession"></textarea>
                  <!-- <div *ngIf="profession.status =='INVALID'&& profession.touched==true " class="invalid-msg">
                    Numbers and Special charaters not allowed</div> -->
                      <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('profession').untouched" [hidden]='hidden'>Please fill this field</div> -->
        
                </div>
        </div>
                <!-- <div class="form-group row">
                          <div class="col-sm-6 mb-3 mb-sm-0">
                              <label>Responsibility For Applying / விண்ணப்பிப்பதற்கான பொறுப்பு<span class="required "> *</span></label><br>
                              <select  name="applied_role"  class="form-control" formControlName="applied_role"  (change)="getapplied(officebearerform.get('applied_role').value)">
                                
                                  <option value="" selected disabled hidden>Select Option</option>
                                 
                                  <option  *ngIf="applied_posting5=='true'"value="மாவட்ட தலைவர்">மாவட்ட தலைவர்</option>
                                  <option *ngIf="applied_posting5=='true'" value="மாவட்ட துணை தலைவர்">மாவட்ட துணை தலைவர்</option>
                                  <option  *ngIf="applied_posting5=='true'" value="மாவட்ட அமைப்பாளர்">மாவட்ட அமைப்பாளர்</option>
                                  <option  *ngIf="applied_posting5=='true'" value="மாவட்ட துணை அமைப்பாளர்">மாவட்ட துணை அமைப்பாளர்</option>

                                  <option  *ngIf="applied_posting6=='true'" value="மாநகர அமைப்பாளர்">மாநகர அமைப்பாளர்</option>
                                  <option  *ngIf="applied_posting6=='true'" value="மாநகர துணை அமைப்பாளர்">மாநகர துணை அமைப்பாளர்</option>

                                  <option  *ngIf="applied_posting7=='true'" value="ஒன்றிய அமைப்பாளர்">ஒன்றிய அமைப்பாளர்</option>
                                  <option  *ngIf="applied_posting7=='true'" value="ஒன்றிய துணை அமைப்பாளர்">ஒன்றிய துணை அமைப்பாளர்</option>

                                  <option  *ngIf="applied_posting8=='true'" value="நகர அமைப்பாளார்">நகர அமைப்பாளார்</option>
                                  <option  *ngIf="applied_posting8=='true'" value="நகர துணை அமைப்பாளர்">நகர துணை அமைப்பாளர்</option>
                                   
                                  <option  *ngIf="applied_posting9=='true'" value="பகுதி அமைப்பாளர்">பகுதி அமைப்பாளர்</option>
                                  <option  *ngIf="applied_posting9=='true'" value="பகுதி துணை அமைப்பாளர்">பகுதி துணை அமைப்பாளர்</option>

                                  <option  *ngIf="applied_posting10=='true'" value="பேரூர் அமைப்பாளர்">பேரூர் அமைப்பாளர்</option>
                                  <option  *ngIf="applied_posting10=='true'" value="பேரூர் துணை அமைப்பாளர்">பேரூர் துணை அமைப்பாளர்</option>
                              
                              </select>
                            
                          
                                <div  *ngIf="(officebearerform.get('applied_role').touched && applied_role.value=='')"
                                class="invalid-msg" >Please select this field</div>
                                <div  class="invalid-msg" *ngIf="officebearerform.get('applied_role').untouched" [hidden]='hidden'>Please select this field</div>
                                <div  class="invalid-msg" *ngIf="applied_role4=='true' && officebearerform.get('applied_role').value !=''" >The maximum number of user for this role has been created</div>
                          </div>

                          <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Status / நிலை<span class="required "> *</span></label><br>
                            <select name="approval_status" formControlName="approval_status"  class="form-control">
                                <option value="" disabled selected hidden>Select Option</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            <<div *ngIf="stateadminform.get('approval_status').hasError('required')"
                            class="invalid-msg" [hidden]='hidden'>Please select the Status
                          </div> -->
                <!-- </div>
                    </div> -->

                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Door no or Flat no / கதவு எண் அல்லது பிளாட் எண்</label>
                    <input pInputText name="address" class="form-control"
                      placeholder="Door no or Flat no / கதவு எண் அல்லது பிளாட் எண்" formControlName="flat_no" />

                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Street name / தெருவின் பெயர்</label>
                    <input pInputText name="street_name" class="form-control" placeholder="Street name / தெருவின் பெயர்"
                      formControlName="street_name" />

                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Town or City / நகரம்</label>
                    <input pInputText name="town_city" class="form-control" placeholder="Town or City / நகரம்"
                      formControlName="town_city" />

                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Taluk / தாலுக்கா</label>
                    <input pInputText name="taluk" class="form-control" placeholder="Taluk / தாலுக்கா"
                      formControlName="taluk" />

                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Pincode / அஞ்சல் குறியீடு</label>
                    <input pInputText name="pincode" class="form-control" placeholder="Pincode / அஞ்சல் குறியீடு" maxlength="6"
                      formControlName="pincode" /> 
                      <div *ngIf="pincode.status=='INVALID'&& pincode.touched==true " class="invalid-msg">
                        Please enter valid pincode</div>

                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Status / நிலை<span class="required "> *</span></label><br>
                    <select name="approval_status" formControlName="approval_status" class="form-control">
                      <option value="" disabled selected hidden>Select Option</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    <div  *ngIf="(officebearerform.get('approval_status').touched && officebearerform.get('approval_status').value=='')"
                        class="invalid-msg" >Please fill this field</div>
                        <div  class="invalid-msg" *ngIf="officebearerform.get('approval_status').untouched && officebearerform.get('approval_status').value==''" [hidden]='hidden'>Please fill this field</div>
                  </div>
                </div>
                <div class="form-group row">

                  <div class="col-sm-12 mb-3 mb-sm-0">
                    <label>Comments</label>
                    <textarea name="party_comments" pInputText class="form-control" placeholder="Enter Comments"
                      cols="100" rows="5" formControlName="party_comments"></textarea>
                    <!-- <div  *ngIf="(officebearerform.get('party_comments').touched && party_comments.value=='')"
                                      class="invalid-msg" >Please fill this field</div>
                                      <div  class="invalid-msg" *ngIf="officebearerform.get('party_comments').untouched" [hidden]='hidden'>Please fill this field</div> -->
                  </div>
                </div>
                <div *ngIf="imageField" class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                      <label>Photo<span class="required "> *</span></label>
                      <input
                      type="file"
                      name="images"
                      class="form-control"
                      accept="image/*"
                      (change)="onFileChange($event, 'create')">
                      <div *ngIf="!imageSrc"
                        class="invalid-msg" [hidden]='hidden'>Please fill out this field
                        </div>
                    <div *ngIf="fileFormatStatus" class="invalid-msg" >
                      Only allowed extensions are .png .jpeg .jpg</div>
                    <div *ngIf="fileSizeStatus" class="invalid-msg" >
                      Maximum allowed file size is 60KB</div>
                    

                  </div>

                  <img [src]="imageSrc"  alt="User Image" *ngIf="imageSrc" style="height: 190px; width:160px; border: 1px solid #555; " >

                </div>

                <div class="form-group row">

                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <input type="text"  hidden formControlName="mode" />
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <input type="text" hidden  formControlName="location_id" />
                  </div>
                </div>
                <!-- <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Status / நிலை</label>
                              <input pInputText type="text" hidden class="form-control" name="mode" formControlName="mode"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Status / நிலை</label>
                              <input pInputText type="text" hidden class="form-control" name="location_id" formControlName="location_id"/>
                            </div>
                        </div> -->
                <div class="d-flex justify-content-center">
                  <div style="width:200px">
                    <button class="btn btn-danger btn btn-block" data-toggle="modal" data-target="#message"  [hidden]="partyDesignation" 
                      data-backdrop="false">Create Office Bearer</button>
                  </div>

                  <div style="width:200px">
                    <button class="btn btn-danger btn btn-block" [hidden]="!partyDesignation" 
                     >Update district admin </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- OFFICE BEARER DATATABLE         -->
    <div class="card-body">
      <div class="table-responsive" *ngIf="tableshow">
        <!-- TABLE -->
        <table class="table table-bordered display" [dtOptions]="dtOptions[0]" datatable>
          <thead>
            <tr>
              <th>Name</th>
              <!-- <th>Designation</th> -->
              <!-- <th>Applied role</th> -->
              <!-- <th>Status</th> -->
              <th>Email</th>
              <th>Role</th>
              <th>Contact no</th>

              <th [hidden]="isButtonDisabled">Show</th>
              <th [hidden]="isButtonDisabled" >Edit</th>
              <th [hidden]="isButtonDisabled">Delete</th>
            
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let customer of customers">
              <td style="min-width: 20px;">
                {{customer.name}}
              </td>
              <!-- <td style="min-width: 20px;">
                  {{customer.designation}}
                  </td> -->
              <!-- <td style="min-width: 20px;">
                  {{customer.applied_role}}
                  </td> -->
              <!-- <td style="min-width: 20px;">
                  {{customer.approval_status}}
                  </td> -->
              <td style="min-width: 20px;">
                {{customer.email}}
              </td>
              <td style="min-width: 20px;">
                {{customer.applied_role}}
              </td>
              <td style="min-width: 20px;">
                {{customer.contact_no}}
              </td>
              <td  [hidden]="isButtonDisabled" ><a data-toggle="modal" data-target="#showDialog" class="btn btn-primary btn-circle btn-sm" 
                  (click)="editbuttonviewOB(customer)">
                  <i class="fas fa-flag"></i>
                </a></td>
              <td [hidden]="isButtonDisabled"><a data-toggle="modal" data-target="#modal-xl" class="btn btn-info btn-circle btn-sm"
                  (click)="editbuttonviewOB(customer);get_oldmail(customer)">
                  <i class="fas fa-check"></i>
                </a></td>
              <td [hidden]="isButtonDisabled"><a class="btn btn-danger btn-circle btn-sm" (click)="delete_ob(customer.id)">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

</div>

<!-- <div class="modal fade" id="requestDialog">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="card-danger">
        <div class="card-header">
          <h3 class="card-title">Request Office Bearer Role Chage</h3>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="card-body">

          <form class="request-form" [formGroup]='reqform' (ngSubmit)="postdata1(reqform)" autocomplete="off">
            <div class="form-group">
              <div class="col-6 md:col-6">
                <input type="text" pInputText hidden name="user_id" formControlName="user_id" [value]="OBid"
                  placeholder="obid" />

              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label>First Name</label><span class="required "> *</span>
                <input pInputText type="text" name="name" class="form-control" placeholder="Enter Name"
                  [value]="OBname+OBlastname" formControlName="name" />
                <div *ngIf="reqform.get('name').hasError('required') && reqform.get('name').touched"
                  class="invalid-msg">Please fill out this field
                </div>
              </div>

            </div>
            <div class="form-group row">
              <div class="col-12 md:col-12">
                <label>Email</label><span class="required "> *</span>
                <input pInputText type="text" name="email1" class="form-control" placeholder="Email"
                  formControlName="email1" />
                <div *ngIf="reqform.get('email1').hasError('email') && reqform.get('email1').touched"
                  class="invalid-msg">Please fill out this field
                </div>
              </div>

            </div>
            <div class="form-group">
              <div class="col-12 md:col-12">
                <label>Old Designation</label><span class="required "> *</span>
                <input pInputText type="text" name="old_designation" class="form-control" placeholder="Old Designation"
                  formControlName="old_designation" />
              </div>

            </div>

            <div class="form-group ">
              <div class="col-12 md:col-12">
                <label>New Designation</label><span class="required "> *</span>
                <input pInputText type="text" name="new_designation1" class="form-control"
                  formControlName="new_designation1" placeholder="New Designation">
                <div
                  *ngIf="reqform.get('new_designation1').hasError('new_designation1') && reqform.get('new_designation1').touched"
                  class="invalid-msg">Please fill out this field
                </div>
              </div>
            </div>
            <div class="form-group ">
              <div class="col-12 md:col-12">
                <label>Reason</label><span class="required "> *</span>
                <input pInputText type="text" name="reason" class="form-control" formControlName="reason"
                  placeholder="Reason ">
              </div>
            </div>
            <div class="col-3" style="margin-left:34%;">
              <button class="btn btn-danger btn btn-block">
                REQUEST APPLY
              </button>
            </div>



          </form>
        </div>
      </div>
    </div>
  </div>
</div> -->






<div class="modal fade show" id="message"
   *ngIf="officebearerform.status=='VALID' && constituency !='' && test_email=='false'&& test_ph=='false' "> 
  <div class="modal-dialog modal-m" style="margin-top:10%;">
    <div class="modal-content">

      <div style="width:100%;height:200%">
        <div class="card-danger" style="width:100%;height:200%">
          <div class="card-header">


            <h3 class="card-title">Office Bearer Credentials</h3>
            <!-- <button type="button" class="close" data-dismiss="modal" *ngIf="user_password==null">&times;</button> -->
          </div>

          <div class="card-body">


            <label>Please access the portal using the following details</label>
            <div class="form-group row">
              <div class="col-12">
                <label>Application Link : </label> <a href="https://app.dmkengwing.in" target="_blank" class="link-danger">
                  https://app.dmkengwing.in</a>

                <div class="loader-container">
                  <div *ngIf="user_password==null" class="loader"></div>
                </div>
              </div>

              <div class="col-12">
                <label>Username :</label> {{username}}
                <div>
                  <!-- <label type="text"  class="form-control"
                                  placeholder="Enter First Name / முதல் பெயர்99" [value]="username"></label> -->
                </div>
              </div>

              <div class="col-12">
                <label>Password :</label> {{user_password}}
              </div>



              <div class="col-6 align-center" style="margin-left:43%;">
                <button class="btn btn-danger btn btn-block" style="height:40px;width:50px" (click)="reload()"
                  *ngIf="username!=null">OK</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>